/* istanbul ignore file */

/**
 * All background positions available.
 */
export enum BackgroundPosition {
    topCenter = 'top center',
    topLeft = 'top left',
    topRight = 'top right',
    bottomCenter = 'bottom center',
    bottomLeft = 'bottom left',
    bottomRight = 'bottom right',
    centerCenter = 'center center',
    centerLeft = 'center left',
    centerRight = 'center right',
}

/**
 * All background size available.
 */
export enum BackgroundSize {
    contain = 'contain',
    auto = 'auto',
}

/**
 * All possible display.
 */
export enum Display {
    block = 'block',
    flex = 'flex',
}

/**
 * All possible justify contents.
 */
export enum FlexAlignment {
    flexStart = 'flex-start',
    center = 'center',
    flexEnd = 'flex-end',
}

/**
 * All possible justify contents.
 */
export enum FlexDirection {
    column = 'column',
    columnReverse = 'column-reverse',
    rowReverse = 'row-reverse',
    row = 'row',
}
